module.exports = __webpack_public_path__ + "img/127.4.a1e39b0b.png";